import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-px-12" }

import { reactive, toValue, ref, watch, Ref } from 'vue'
import _ from 'lodash'

interface IProps {
  menuItems: IMenuItem[]
  search?: string
}

interface IMenuItem {
  section: string
  items: [{ title: string; icon: string; model: number }]
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SettingMenu' },
  __name: 'SettingMenu',
  props: /*@__PURE__*/_mergeModels({
    menuItems: {},
    search: { default: '' }
  }, {
    "modelValue": { type: Number, required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel(__props, "modelValue")
const props = __props

const state = reactive(toValue(() => props))
const isExpansionOpen: Ref<boolean[]> = ref([])

watch(
  model,
  () => {
    isExpansionOpen.value = props.search
      ? Array(props.menuItems.length).fill(true)
      : state.menuItems.map((section) => section.items.some((item) => item.model === model.value))
  },
  { immediate: true },
)

watch(
  () => props.search,
  () => {
    isExpansionOpen.value = props.search
      ? Array(props.menuItems.length).fill(true)
      : (isExpansionOpen.value = state.menuItems.map((section) =>
          section.items.some((item) => item.model === model.value),
        ))
  },
)

return (_ctx: any,_cache: any) => {
  const _component_SettingCell = _resolveComponent("SettingCell")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.menuItems, (menuItem, menuIndex) => {
    return (_openBlock(), _createElementBlock("div", {
      key: menuIndex,
      class: "SettingMenu"
    }, [
      _createVNode(_component_q_expansion_item, {
        modelValue: isExpansionOpen.value[menuIndex],
        "onUpdate:modelValue": ($event: any) => ((isExpansionOpen.value[menuIndex]) = $event),
        label: menuItem.section,
        "header-class": "fs-15px fw-500"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_SettingCell, {
              key: index,
              modelValue: model.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
              page: item.model,
              icon: item.icon,
              title: item.title,
              onClick: ($event: any) => (model.value = item.model)
            }, null, 8, ["modelValue", "page", "icon", "title", "onClick"]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "label"]),
      _createElementVNode("div", _hoisted_1, [
        (menuIndex !== menuItem.items.length)
          ? (_openBlock(), _createBlock(_component_k_divider, {
              key: 0,
              size: "sm",
              color: "cool-gray-50",
              class: "q-my-12",
              dotted: ""
            }))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}
}

})